import type { Resource } from '../../';
export const product_tiles_selectColor: Resource = {"default":"Select color {colorName}"};
